import useIsMobile from 'hooks/use-is-mobile';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router';
import { push } from 'store/router/router-actions';
export const useHideSpotDetails = () => {
    const isMobile = useIsMobile();
    const history = useHistory();
    const dispatch = useDispatch();
    const onSpotDetailsHidden = () => {
        const queryParams = new URLSearchParams(history.location.search);
        queryParams.delete('spot-id');
        dispatch(push(`${history.location.pathname}?${queryParams.toString()}`, {
            reload: isMobile, // Only reload if this is mobile
        }));
    };
    return onSpotDetailsHidden;
};
